import { jsx } from "react/jsx-runtime";
const Plus = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            d: "M13 4.929a1 1 0 1 0-2 0V11H4.93a1 1 0 1 0 0 2H11v6.071a1 1 0 1 0 2 0V13h6.071a1 1 0 1 0 0-2H13V4.929Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Plus_Plus = Plus;
export default Plus_Plus;
